/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../_helpers";

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};
function generateIcone(Entity) {
  var classe = "";
  switch (Entity) {
    case "Orders":
      classe = "flaticon2-supermarket";
      break;
    case "Patients":
      classe = "flaticon-users";
      break;
    default:
      classe = "flaticon2-supermarket";
  }
  return classe;
}
export function SearchResult({ data, searchValue, setSearchValue }) {
  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return (
      <div
        style={{ maxHeight: "325px", overflow: "hidden" }}
        className="quick-search-wrapper scroll ps ps--active-y"
      >
        <div className="quick-search-result">
          <div className="text-muted d-none">No record found</div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{ maxHeight: "325px", overflow: "hidden" }}
      className="quick-search-wrapper scroll ps ps--active-y"
    >
      <PerfectScrollbar
        options={perfectScrollbarOptions}
        className="scroll"
        style={{ maxHeight: "325px", position: "relative" }}
      >
        <div className="quick-search-result">
          {/* begin: Section */}
          <div className="font-size-sm text-primary font-weight-bolder text-uppercase mb-2">
            Results
          </div>
          <div className="mb-10">
            {data.map((item, index) => (
              <div
                className="d-flex align-items-center flex-grow-1 mb-2"
                key={index}
              >
                <div className="symbol symbol-45 symbol-circle flex-shrink-0">
                  <div className="symbol-label">
                    <i
                      className={`${generateIcone(item.entity)} text-primary`}
                    ></i>
                  </div>
                </div>
                <div className="d-flex flex-column ml-3 mt-2 mb-2">
                  <Link
                    className="font-weight-bold text-dark text-hover-primary"
                    to={`/search?entity=${item.entity}&key=${searchValue}`}
                  >
                    {item.entity} ({item.number} results)
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </PerfectScrollbar>
    </div>
  );
}
